import { ValidateMedicalsWarningMessageType } from "@/types/renewals";

import { useFetchMagnoliaModal } from "./use-fetch-magnolia-modal";

const initialData: ValidateMedicalsWarningMessageType = {
  name: "",
  modalTitle: "Validate Medicals",
  modalDescription: "Please re check all the medicals",
  ctaButtonLabel: "Continue",
  backButtonLabel: "Go back",
};

/**
 * Hook for fetching medical validation warning modal content from Magnolia CMS
 * Used in renewal flow to warn users about re-checking medical conditions
 *
 * @returns { data, loading, error } - Modal content and fetch state
 */
export function useFetchValidateMedicalsWarning() {
  return useFetchMagnoliaModal<ValidateMedicalsWarningMessageType>(
    "/renewal-medical-warning-modal",
    initialData,
    "Failed to fetch validate medicals warning data"
  );
}
